import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const ProtectedRoute = () => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  // While MSAL is handling redirect / sign-in. A popup sign-in for the API token
  // (utils/apiFetch -> SessionExpiredModal) must NOT unmount the page, or the person
  // would lose what they are editing.
  const renewingApiToken = isAuthenticated && inProgress === InteractionStatus.AcquireToken;
  if (inProgress !== InteractionStatus.None && !renewingApiToken) {
    return (
      <div className="auth-loading">
        <p>Checking authentication...</p>
      </div>
    );
  }

  // Not authenticated → send to login
  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Authenticated → allow access
  return <Outlet />;
};

export default ProtectedRoute;
